<template>
  <section class="cn-links">
    <div class="profile-wrap">
      <img src="/static/assets/images/Dwerve-Title-PJ.png" alt="dwerve" class="profile-img"/>
    </div>
    <div class="links-wrap">
      <a href="https://store.steampowered.com/app/1132760/Dwerve/" target="_blank">Steam | 添加至您的愿望单</a>
      <a href="https://weibo.com/7683382579/profile?topnav=1&wvr=6&is_all=1" target="_blank">微博 | Dwerve战匠杜沃</a>
      <a href="https://weibo.com/u/7424110798?refer_flag=1001030103_" target="_blank">微博 | 电子羊梦境管理中心</a>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
      document.querySelector(".page-loader").style.zIndex = 1;
      document.querySelector("#navbar").style.display = "none";
      document.querySelector("#socialNav").style.display = "none";
      document.querySelector("#scroll-up").style.display = "none";
  }
};
</script>

<style>
@media only screen and (min-width: 900px){
    .cn-links .links-wrap {
      bottom: inherit;
    }
}
.cn-links::before {
    background-image: url(/static/assets/images/dwerve-pax.png);
    height: 100vh;
    background-position: 47% 103%;
    background-repeat: no-repeat;
    content: "";
    background-size: cover;
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    opacity: 0.4;
}
.profile-wrap img {
    display: block;
    object-fit: contain;
    object-position: initial;
    filter: none;
    margin: auto;
}

.profile-wrap {
    text-align: center;
    margin-top: 15px;
    position: relative;
    max-width: 600px;
    margin: auto;
}

.links-wrap a {
    display: block;
    z-index: 0;
    overflow: hidden;
    margin-bottom: 16px;
    border: 2px solid rgb(79, 124, 254);
    background: rgb(79, 124, 254);
    color: rgb(255, 255, 255);
    border-radius: 3px;
    font-size: 16px;
    padding: 10px;
    width: 95%;
    margin: 16px auto;
    box-shadow: 4px 8px 1px 0 rgb(20 51 140);
}

.links-wrap {
    width: 100%;
    margin: auto;
    text-align: center;
    position: absolute;
    bottom: 10px;
    max-width: 400px;
    left: 0;
    right: 0;
}

.profile-wrap h1 {
    color: #fff;
    font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/views/Links.vue